import { render, staticRenderFns } from "./GymChart.vue?vue&type=template&id=b39626a6&scoped=true"
import script from "./GymChart.vue?vue&type=script&lang=js"
export * from "./GymChart.vue?vue&type=script&lang=js"
import style0 from "./GymChart.vue?vue&type=style&index=0&id=b39626a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39626a6",
  null
  
)

export default component.exports